module.exports = __webpack_public_path__ + "static/media/percent.1e29c87b.svg";